import { Sizes, Tags, TagType } from '@agilox/ui-common';
import { Component, computed, input, output } from '@angular/core';
import { IconModule } from '../icon/icon.module';

@Component({
	selector: 'ui-tag',
	imports: [IconModule],
	templateUrl: './tag.component.html',
})
export class TagComponent {
	type = input<TagType>(Tags.PrimaryLight);
	text = input<string>('');
	icon = input<string | undefined>();

	iconClicked = output<void>();
	public sizes = Sizes;

	onIconClick() {
		this.iconClicked.emit();
	}

	variant = computed(() => {
		switch (this.type()) {
			case Tags.SecondaryLight:
				return 'bg-secondary-200 text-secondary-800';
			case Tags.Dark:
				return 'bg-secondary-800 text-white';
			case Tags.Warning:
				return 'bg-warning text-secondary-800 dark:text-white';
			case Tags.Alert:
				return 'bg-error text-white dark:text-secondary-800';
			case Tags.Primary:
				return 'bg-primary-800 text-white dark:text-secondary-900';
			case Tags.PrimaryLight:
			default:
				return 'bg-primary-200 text-secondary-800';
		}
	});
}
